import { ButtonGroupInputOption } from '@/components/form/baseInputs/inputTypes';
import { SummaryBeneficiaryKindv2 } from '@/types/schema';

export interface FormType {
  selectedTrusts: { id: string; selected: boolean }[];
  selectedIndividuals: { id: string; selected: boolean }[];
  selectedSubTrusts: { id: string; selected: boolean }[];
}

export enum PickerTab {
  Trusts = 'trusts',
  SubTrusts = 'subTrusts',
  Individuals = 'individuals',
}

export const TABS = [
  { display: 'Trusts', value: PickerTab.Trusts },
  { display: 'Sub-trusts', value: PickerTab.SubTrusts },
  { display: 'Individual beneficiaries', value: PickerTab.Individuals },
] as const;

export const TAB_OPTIONS: ButtonGroupInputOption[] = TABS.slice();

export interface Option {
  id: string;
  displayName: string;
  description: string;
  type: SummaryBeneficiaryKindv2;
  summary: string;
}
